import React from 'react';
import { Descendant } from 'slate';
import { withHttp } from '@/utils/url';
import { LinkElement } from '@/typings/editor';
import style from './index.module.css';

const InlineChromiumBugfix = () => (
  <span contentEditable={false}>{String.fromCodePoint(160) /* Non-breaking space */}</span>
);

export const LinkComponent = ({
  attributes,
  children,
  element,
  readOnly,
}: {
  attributes: any;
  children: Descendant[];
  element: LinkElement;
  readOnly?: boolean;
}) => {
  return readOnly ? (
    <a href={withHttp(element.url)} target="_blank" className={style.linkElement} rel="noreferrer">
      {children}
    </a>
  ) : (
    <a {...attributes} href={element.url} className={style.linkElement}>
      <InlineChromiumBugfix />
      {children}
      <InlineChromiumBugfix />
    </a>
  );
};
